export const MARKET_WATCH_EVENT_TITLE = {
    PriceGainers_: 'gainers',
    PriceLoosers_: 'losers',
    '52WeekHigh_': '52 week high',
    '52WeekLow_': '52 week low',
};

export const MARKET_WATCH_FIRST_TABS = 'gainers';

export const MARKET_WATCH_TABS_MAP = {
    gainers: {
        tabName: 'Gainers',
        tabId: 'PriceGainers_',
        dataAid: 'gainers',
        eventTabName: MARKET_WATCH_EVENT_TITLE.PriceGainers_,
    },
    losers: {
        tabName: 'Losers',
        tabId: 'PriceLoosers_',
        dataAid: 'losers',
        eventTabName: MARKET_WATCH_EVENT_TITLE.PriceLoosers_,
    },
    '52_week_high': {
        tabName: '52 week high',
        tabId: '52WeekHigh_',
        dataAid: '52WeekHigh',
        eventTabName: MARKET_WATCH_EVENT_TITLE['52WeekHigh_'],
    },
    '52_week_low': {
        tabName: '52 week low',
        tabId: '52WeekLow_',
        dataAid: '52WeekLow',
        eventTabName: MARKET_WATCH_EVENT_TITLE['52WeekLow_'],
    },
};


export const MARKET_WATCH_TABS = [
	MARKET_WATCH_TABS_MAP.gainers,
	MARKET_WATCH_TABS_MAP.losers,
	MARKET_WATCH_TABS_MAP['52_week_high'],
	MARKET_WATCH_TABS_MAP['52_week_low'],
];

export const MARKET_WATCH_SCREENER_KEY = {
    gainers: 'PriceGainers_',
    losers: 'PriceLoosers_',
    weekHigh: '52WeekHigh_',
    weekLow: '52WeekLow_',
};

export const MARKET_WATCH_SCREENER_KEY_LIST = [
    MARKET_WATCH_SCREENER_KEY.gainers,
    MARKET_WATCH_SCREENER_KEY.losers,
    MARKET_WATCH_SCREENER_KEY.weekHigh,
    MARKET_WATCH_SCREENER_KEY.weekLow,
];

export const STOCK_LANDING_MW_PAYLOAD = {
    segment: 1,
    screenerKeys: MARKET_WATCH_SCREENER_KEY_LIST,
    indexName: 'Nifty 50',
};
